import {BaseService} from "./base.service";

class PlansService extends BaseService {

    constructor() {
        super('api/kind-plans')
    }

    getPlansByPackage(id) {
        return this.http.get(`api/get-plans-by-package/${id}`).then(response => response.data).catch(err => err.message);
    }

}

export const plansService = new PlansService();
